var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Classes.SearchManagerMobile = new Class({
    Extends: OCS.WxBriefing.Classes.SearchManager,
    options: {
        search_input_container_id: "mobile_search_container",
    },
    on_click_product: function (event, target) {
        var entry_id = target.get('data-entry_id');
        this.finish_search({entry_id: entry_id});
        var cp = document.id("mobile_panel_chooser").retrieve('panel_chooser').current_panel;
        var state = {};
        state['p' + cp] = {};
        state['p' + cp].entry_id = entry_id;
        OCS.WxBriefing.Functions.get_url_manager().update_url_state(state, 0);
        OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
    },
});
